<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-02-15 20:28:18
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-02 10:22:50
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap">
        <h2 class="title">新增人员账号</h2>
      </div>
      <p class="top-tip">
        <i class="el-icon-warning"></i>登录账号及密码同OA系统
      </p>
      <div class="con-wrap">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          label-width="170px"
        >
          <el-form-item label="OA账号" prop="loginName">
            <el-col class="col">
              <el-input
                @change="getOaInfo()"
                v-model.trim="form.loginName"
                placeholder="请输入OA账号"
                maxLength="30"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="员工姓名" prop="fullName">
            <el-col class="col">
              <el-input
                v-model.trim="form.fullName"
                placeholder="请输入员工姓名"
                maxLength="30"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-col class="col">
              <el-input
                v-model.trim="form.mobile"
                placeholder="请输入手机号"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxLength="11"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="选择角色权限" prop="roleIds">
            <el-col class="col">
              <el-checkbox-group
                v-model.trim="form.roleIds"
                @change="handleChangeRole"
              >
                <el-checkbox
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.id"
                  name="roleIds"
                  >{{ item.roleName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-col>
          </el-form-item>
          <el-form-item class="form-item-submit">
            <el-button type="primary" @click="handleSubmit('ruleForm')"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
        <div class="auth-panel" v-if="form.roleIds.length > 0">
          <div class="con">
            <h4 class="title"><i class="left"></i>该账号将具有的权限</h4>
            <el-tree
              v-loading="authLoading"
              class="auth-tree"
              :data="authData"
              :props="defaultProps"
              accordion
            >
            </el-tree>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      form: {
        loginName: "",
        fullName: "",
        mobile: "",
        cusId: "",
        roleIds: [],
      },
      rules: {
        loginName: {
          required: true,
          message: "请输入OA账号",
          trigger: "blur",
        },
        roleIds: {
          required: true,
          message: "请选择角色权限",
          trigger: "change",
        },
      },
      codeShow: true,
      count: "",
      timer: null,
      roles: [],
      authData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      authLoading: false,
      oaInfo: "", // OA账号信息
    };
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    getRoleList() {
      let params = {
        roleType: 2,
      };
      this.$http.account.getAllSRoleList(params).then((res) => {
        this.roles = res.data;
      });
    },
    /**
     * @descripttion: 提交信息
     * @Author: juanjuanhui
     * @Date: 2021-11-17 10:44:50
     * @param {*} formName
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = { ...this.form };
          this.$http.account.addManageAccount(params).then((res) => {
            if (res.status == 1) {
              this.$message({
                type: "success",
                message: "新增账号成功",
                duration: 2000,
              });
              this.$router.go(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 根据oa登录账号查账号信息
     * @Author: yangsibo
     * @Date: 2022-05-26 16:49:25
     * @return {*}
     */
    async getOaInfo() {
      try {
        let loginName = this.form.loginName;
        let { status, data } = await this.$http.account.getOaInfo({
          loginName,
        });
        if (status == "1" && data) {
          this.form.cusId = data.admin.id;
          this.form.fullName = data.admin.fullname;
          this.form.mobile = data.admin.mobile;
        }
        if (status == "0") {
          this.form.loginName = "";
        }
      } catch (error) {
        this.form.loginName = "";
      }
    },
    /**
     * @descripttion: 选择角色
     * @Author: juanjuanhui
     * @Date: 2022-02-17 17:00:14
     * @param {*} data 已选项
     */
    handleChangeRole(data) {
      this.authLoading = true;
      this.authData = [];
      if (data && data.length > 0) {
        let params = {
          roleIdList: data,
        };
        this.$http.common
          .selectOwnSMenuTree(params)
          .then((res) => {
            this.authData = res.data;
            this.authLoading = false;
          })
          .catch(() => {
            this.authLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
@import "@/styles/common.scss";
.main {
  .title-wrap {
    @include plate-title-mutil;
    height: 44px;
    border-bottom: 1px solid #efefef;
    margin-bottom: 16px;
    padding-bottom: 10px;
    box-sizing: border-box;
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
    }
  }
  .top-tip {
    padding-bottom: 16px;
    color: #018388;
    i {
      margin-right: 5px;
    }
  }
  .con-wrap {
    display: flex;
    ::v-deep .el-form {
      width: 600px;
      .el-form-item {
        margin-bottom: 20px;
        &.form-item-submit {
          .el-button {
            width: 120px;
            font-size: 18px;
          }
        }
        &.form-item-sms {
          .col {
            display: flex;
            justify-content: space-between;
            border: 1px solid #dcdfe6;
            .el-input {
              width: 250px;
              .el-input__inner {
                border: none;
              }
            }
            .code {
              padding: 0 8px;
              color: #018388;
              font-size: 16px;
              cursor: pointer;
            }
          }
        }
        .tip {
          height: 34px;
          font-size: 14px;
          color: #acacac;
        }
        .col {
          width: 360px;
        }
        .el-checkbox__label {
          font-size: 16px;
        }
        .el-form-item__error {
          position: absolute;
          float: none;
          padding-top: 2px;
          padding-left: 0 !important;
          font-size: 14px;
          line-height: 1;
        }
      }
    }
    .auth-panel {
      .con {
        width: 277px;
        border-radius: 2px;
        border: solid 1px #e5e6eb;
        .title {
          position: relative;
          height: 40px;
          padding: 0 16px;
          line-height: 40px;
          background-color: #fbfbfb;
          border-bottom: solid 1px #e5e6eb;
          font-size: 16px;
          color: #222222;
          .left {
            position: absolute;
            top: 13px;
            left: -8px;
            width: 14px;
            height: 14px;
            border-top: 1px solid #e5e6eb;
            border-right: 1px solid #e5e6eb;
            transform: rotate(-135deg);
            background: #fbfbfb;
          }
        }
        ::v-deep .el-tree {
          color: #222222;
          max-height: 345px;
          overflow-y: auto;
          & > .el-tree-node {
            min-height: 40px;
            border-top: solid 1px #e5e6eb;
            &:first-child {
              border-top: none;
            }
            .el-tree-node__content {
              height: 40px;
            }
          }
          & > .el-tree-node:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
